import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RegisterRequest } from '../_models/register-request';
import { User } from '../_models/user';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private headers!: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.headers = this.authService.headers;
  }

  getUser() {
    return this.http.get<User>(`${environment.apiUrl}/account`, { headers: this.authService.headers });
  }

  getUserById(userId: string) {
    return this.http.get<User>(`${environment.apiUrl}/account/userid/${userId}`, { headers: this.authService.headers });
  }

  getUserByResetPasswordTokenId(resetPasswordTokenId: string) {
    return this.http.get<User>(`${environment.apiUrl}/account/userResetPasswordTokenid/${resetPasswordTokenId}`, { headers: this.authService.headers });
  }

  updateUser(user: User) {
    return this.http.put<User>(`${environment.apiUrl}/account`, user, { headers: this.authService.headers });
  }

  updateUserPassword(resetPasswordToken: string, password: string) {
    return this.http.put<User>(`${environment.apiUrl}/account/update_password`, { resetPasswordToken, password }, { headers: this.authService.headers });
  }

  getBlockedEmailDomains() {
    return this.http.get<string[]>(`${environment.apiUrl}/account/blockedEmailDomains`);
  }

  register(payload: RegisterRequest) {
    return this.http.post(`${environment.apiUrl}/account/register`, payload);
  }

  getRegisterRequests() {
    return this.http.get<RegisterRequest[]>(`${environment.apiUrl}/account/registerRequests`, { headers: this.authService.headers });
  }

  validateRegisterRequest(id: string) {
    return this.http.post(`${environment.apiUrl}/account/registerRequests/${id}/validate`, null, { headers: this.authService.headers });
  }

  refuseRegisterRequest(id: string) {
    return this.http.post(`${environment.apiUrl}/account/registerRequests/${id}/refuse`, null, { headers: this.authService.headers });
  }
}
